var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M15.7986 14H8.16746C7.5589 14 7.25413 13.148 7.68445 12.6498L11.5 8.23167C11.7668 7.92278 12.1993 7.92278 12.466 8.23166L16.2816 12.6498C16.7119 13.148 16.4071 14 15.7986 14Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }